'use client';

import { Exception } from "sass";

//import { usePathname } from 'next/navigation'


export default class AuthStorage {

    constructor(pathName) {

        //console.log("Auth, pathName");

        if (pathName === "" || pathName === undefined) {
            throw new Exception("Falta parametro pathName");
        }
        if (typeof window === 'undefined') {
            throw new Exception("No se puede instanciar porque windows no existe");
        }


        let pathExcepciones = [
            "/reciboPago/", "/medicionRA/", "/formatoPendiente/", "/encuesta/", "/l/", "/s/",
            "/external/", "/homeguest/", "/credito/","/firmaPagareCodeudor/", "/cauGuest/"
        ];

        this.esLocalStorage = pathExcepciones.find(x => pathName.toLowerCase() === x.toLowerCase()) === undefined;

    }

    setConfigSubdomain(payload) {

        const authStorage = new AuthStorage(window.location.pathname);

        //const userDetails = authStorage.GetCurrentUser();

        if (this.esLocalStorage) {
            localStorage.setItem('configDomain', JSON.stringify(payload));
        }
        else {
            sessionStorage.setItem('configDomain', JSON.stringify(payload));
        }

    }

    getConfigSubdomain() {


        let dataConfig = {
            subdomain: '',
            idSuscripcion: -1,
            idEmpresaInit: -1,
            idiomaInit: '',
            title: '',
            urlLogoLogin: '',
            urlLogoFavicon: '',
            urlLogoMenu: '',
        };

        if (typeof window !== 'undefined') {

            let valueCurrentConfigDomain;
            if (this.esLocalStorage) { valueCurrentConfigDomain = window.localStorage.getItem('configDomain'); }
            else { valueCurrentConfigDomain = sessionStorage.getItem('configDomain'); }

            let currentConfigDomain = JSON.parse(valueCurrentConfigDomain);
            let idSuscripcion = currentConfigDomain ? currentConfigDomain.idSuscripcion : -1;
            let idEmpresaInit = currentConfigDomain ? currentConfigDomain.idEmpresaInit : -1;
            let idiomaInit = currentConfigDomain ? currentConfigDomain.idiomaInit : 'ES';
            let subdomain = currentConfigDomain ? currentConfigDomain.subdomain : '';
            let title = currentConfigDomain ? currentConfigDomain.title : '';

            let urlLogoLogin = currentConfigDomain ? currentConfigDomain.urlLogoLogin : '';
            let urlLogoFavicon = currentConfigDomain ? currentConfigDomain.urlLogoFavicon : '';
            let urlLogoMenu = currentConfigDomain ? currentConfigDomain.urlLogoMenu : '';

            dataConfig = {
                subdomain: subdomain || '',
                idSuscripcion: idSuscripcion || -1,
                idEmpresaInit: idEmpresaInit || -1,
                idiomaInit: idiomaInit || '',
                title: title || '',
                urlLogoLogin: urlLogoLogin || '',
                urlLogoFavicon: urlLogoFavicon || '',
                urlLogoMenu: urlLogoMenu || '',
            };

        }

        return dataConfig;

    }

    setCurrentUser(payload) {

        if (this.esLocalStorage) {
            window.localStorage.setItem('currentUser', JSON.stringify(payload));
            window.localStorage.setItem("idle_time", 0);
        }
        else {
            window.sessionStorage.setItem('currentUser', JSON.stringify(payload));
            window.sessionStorage.setItem("idle_time", 0);
        }
    }

    removeCurrentUser() {
        if (this.esLocalStorage) {
            window.localStorage.removeItem('currentUser');
            window.localStorage.setItem("idle_time", 0);
        }
        else {
            window.sessionStorage.removeItem('currentUser');
            window.sessionStorage.setItem("idle_time", 0);
        }
    }

    GetCurrentUser() {

        let valueCurrentUser = undefined;

        if (this.esLocalStorage) {
            valueCurrentUser = window.localStorage.getItem('currentUser');
        }
        else {
            valueCurrentUser = window.sessionStorage.getItem('currentUser');
        }


        let currentUser = JSON.parse(valueCurrentUser);
        let userName = currentUser ? currentUser.userName : '';
        let token = currentUser ? currentUser.token : '';
        let subdomain = currentUser ? currentUser.subdomain : '';
        let idSuscripcion = currentUser ? currentUser.idSuscripcion : -1;
        let idEmpresa = currentUser ? currentUser.idEmpresa : -1;
        let idioma = currentUser ? currentUser.idioma : '';
        let sessionGUID = currentUser ? currentUser.sessionGUID : '';
        let token_renewal_errors = currentUser ? currentUser.token_renewal_errors : 0;

        let dataLogin = {
            userName: '' || userName,
            token: '' || token,
            loading: false,
            errorMessage: null,
            subdomain: '' || subdomain,
            idSuscripcion: idSuscripcion || -1,
            idEmpresa: idEmpresa || -1,
            idioma: '' || idioma,
            sessionGUID: '' || sessionGUID,
            token_renewal_errors: token_renewal_errors || 0,

        };

        return dataLogin;
    }

    GetCurrentUserLocal() {

        let valueCurrentUser = undefined;

        valueCurrentUser = localStorage.getItem('currentUser');

        let currentUser = JSON.parse(valueCurrentUser);
        let userName = currentUser ? currentUser.userName : '';
        let token = currentUser ? currentUser.token : '';
        let subdomain = currentUser ? currentUser.subdomain : '';
        let idSuscripcion = currentUser ? currentUser.idSuscripcion : -1;
        let idEmpresa = currentUser ? currentUser.idEmpresa : -1;
        let idioma = currentUser ? currentUser.idioma : '';
        let sessionGUID = currentUser ? currentUser.sessionGUID : '';
        let token_renewal_errors = currentUser ? currentUser.token_renewal_errors : 0;

        let dataLogin = {
            userName: '' || userName,
            token: '' || token,
            loading: false,
            errorMessage: null,
            subdomain: '' || subdomain,
            idSuscripcion: idSuscripcion || -1,
            idEmpresa: idEmpresa || -1,
            idioma: '' || idioma,
            sessionGUID: '' || sessionGUID,
            token_renewal_errors: token_renewal_errors || 0,

        };

        return dataLogin;
    }


    GetCurrentTokenAutorization() {

        let currentToken = undefined;

        if (this.esLocalStorage) {
            currentToken = localStorage.getItem('currentToken');
        }
        else {
            currentToken = sessionStorage.getItem('currentToken');
        }

        let token = currentToken ? JSON.parse(currentToken).token : '';

        let SessionGUID_Token = currentToken ? JSON.parse(currentToken).sessionGUID : '';

        //let currentUser = localStorage.getItem('currentUser');
        //let sessionGUID_User = localStorage.getItem('sessionGUID');

        let dataToken = {
            token: '' || token,
            sessionGUID: '' || SessionGUID_Token,
        };

        return dataToken;

    }

    setCurrentTokenAutorization(payload) {

        if (this.esLocalStorage) {
            window.localStorage.setItem('currentToken', JSON.stringify(payload));
            window.localStorage.setItem("idle_time", 0);
        }
        else {
            window.sessionStorage.setItem('currentToken', JSON.stringify(payload));
            window.sessionStorage.setItem("idle_time", 0);
        }


    }


    setIdleTime(newIdleTime) {

        if (this.esLocalStorage) {
            window.localStorage.setItem("idle_time", newIdleTime);
        }
        else {
            window.sessionStorage.setItem("idle_time", newIdleTime);
        }


    }

    getIdleTime() {

        let res = 0;

        if (this.esLocalStorage) {
            res = window.localStorage.getItem("idle_time");
        }
        else {
            res = window.sessionStorage.getItem("idle_time");
        }

        return res;

    }

    getVersionUpdateNeeded() {
        let res = "";

        if (this.esLocalStorage) {
            res = window.localStorage.getItem("version-update-needed");
        }
        else {
            res = window.sessionStorage.getItem("version-update-needed");
        }
        return res;

    }

    setVersionUpdateNeeded(newVal) {

        if (this.esLocalStorage) {
            window.localStorage.setItem("version-update-needed", newVal);
        }
        else {
            window.sessionStorage.setItem("version-update-needed", newVal);
        }


    }


    removeVersionUpdateNeeded() {

        if (this.esLocalStorage) {
            window.localStorage.removeItem("version-update-needed");
        }
        else {
            window.sessionStorage.removeItem("version-update-needed");
        }


    }

}
